<div class="w-full flex flex-col items-center justify-center gap-2 p-6">


  <div class="flex flex-col items-center justify-center gap-2 p-6 pb-6 z-0 rounded-3xl">
    <!-- <h1 class="text-xl font-medium text-center text-gray-800">Verify your identity with</h1> -->
    <img class="w-[140px] h-full object-cover saturate-0" src="assets/digilocker-logo.webp" alt="ID Card">


  </div>



  @switch(idVerificationStatus){
  @case('started'){
  <div class="flex flex-col items-center justify-center gap-2 p-4 bg-white rounded-3xl 
  pt-6 w-full" sxCenterize="col">

    <ion-skeleton-text class="w-2/4 h-6 rounded-2xl" animated="true">
    </ion-skeleton-text>
    <p class="text-base text-gray-700 mb-10">Authenticating with Digilocker</p>

    <super-button sxWidth="full" type="outline" (click)="cancelDigilocker()">Cancel</super-button>
  </div>
  }
  @case('failed'){
  <div class="flex flex-col items-center justify-center gap-2 p-4 bg-white rounded-3xl 
    pt-6 w-full" sxCenterize="col">

    @switch(digilockerRequest.errorCode){

    @case(DigilockerErrorCode.FACE_NOT_MATCHED){

    @if(faceId?.imageUrl){
    <div class="flex items-center justify-center border border-solid border-red-500 rounded-full p-2">
      <img [src]="ImageUtil.getImageSource(faceId.imageUrl)" alt="Face ID"
        class="size-20 object-cover saturate-0 contrast-100 brightness-150  rounded-full" />
    </div>

    }
    <p class="text-lg text-gray-700 mb-5">Face not matched</p>

    }

    @default {
    <ion-icon class="text-amber-500 text-[44px] mb-4" name="alert-circle-outline"></ion-icon>
    <p class="text-lg text-gray-700 mb-5">Verification failed</p>
    }

    }



    <super-button sxWidth="full" (click)="cancelDigilocker()" iconEnd="arrow-forward">Retry</super-button>
  </div>
  }
  @case('success'){

  <div class="flex flex-col items-center justify-center gap-2 p-4 bg-white rounded-3xl 
      pt-6 w-full" sxCenterize="col">
    <ion-icon class="text-green-500 text-[44px] mb-4" name="checkmark-circle-outline"></ion-icon>

    <p class="text-lg text-gray-700 mb-4">Authenticated</p>
    <div class="flex flex-row items-center justify-center gap-2 mb-10">
      <p class="text-base text-gray-600">Verifying details, please wait...</p>
    </div>
  </div>
  }
  @default{
  @if (prepareError) {
  <p class="text-center text-sm text-red-600 mb-4">{{ prepareError }}</p>
  @if (openBlockedByBrowser) {
  <super-button sxWidth="full" (click)="openDigilockerLink()" iconEnd="arrow-forward">Try again</super-button>
  } @else {
  <super-button sxWidth="full" (click)="prepareDigilockerLink()" iconEnd="arrow-forward">Retry</super-button>
  }
  } @else if (isPreparingDigilocker) {
  <p class="text-center text-sm text-gray-700 mb-4">Preparing DigiLocker…</p>
  <div class="w-[90%] mb-4">
    <ion-progress-bar color="dark" type="indeterminate"></ion-progress-bar>
  </div>
  } @else {
  <p class="text-center text-sm text-gray-700 mb-4">Tap below to open DigiLocker in a new tab. Keep this window open
    until verification finishes.</p>
  <super-button sxWidth="full" (click)="openDigilockerLink()" iconEnd="arrow-forward">Continue to DigiLocker</super-button>
  }

  }
  }



</div>